import gql from 'graphql-tag';

/**
 * Data of the block project-base-information: its top-level fields plus `customer.number` and
 * `sales.inCharge`. Read through `Project.blocks.baseInformation`, which checks the block's read
 * permission.
 */
export const PROJECT_BASE_INFORMATION_FIELDS = gql`
  fragment projectBaseInformationFields on ProjectBaseInformationBlock {
    id
    number
    employer {
      id
      number
      name
    }
    inCharge {
      id
      number
      firstname
      lastname
    }
    employerProjectNumber
    deliveryAt
    businessModelState
    projectTypeState
    projectState
    billingModelState
    businessUnitState
    contractSignedState
    planningHorizonYear
    probabilityOfImplementation
    offerSentAt
    orderConfirmationSentAt
    customer {
      number
    }
    sales {
      inCharge {
        id
        number
        firstname
        lastname
      }
    }
  }
`;
